import React from "react";
import { Navigate, useParams } from "react-router-dom";

// Component to redirect from /blogs/:topic/:titleSlug to /blog/:titleSlug
export const BlogRedirectComponent = () => {
  const { titleSlug = "", topic = "" } = useParams<{ topic: string; titleSlug: string }>();
  
  if (!titleSlug) {
    return <Navigate to="/blogs" replace />;
  }
  
  return <Navigate to={`/blogs/${titleSlug}`} replace />;
};

export default BlogRedirectComponent;
